var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4799 19.4921C28.3296 19.3028 28.151 19.1527 27.9544 19.0502C27.7578 18.9478 27.5471 18.895 27.3343 18.895C27.1215 18.895 26.9107 18.9478 26.7141 19.0502C26.5176 19.1527 26.339 19.3028 26.1887 19.4921L19.8837 27.4138L13.5787 19.4921C13.2748 19.1103 12.8627 18.8959 12.433 18.8959C12.0033 18.8959 11.5912 19.1103 11.2874 19.4921C10.9836 19.8738 10.8129 20.3916 10.8129 20.9315C10.8129 21.4713 10.9836 21.9891 11.2874 22.3708L18.7462 31.7421C18.8965 31.9314 19.0751 32.0815 19.2716 32.184C19.4682 32.2864 19.679 32.3392 19.8918 32.3392C20.1046 32.3392 20.3153 32.2864 20.5119 32.184C20.7085 32.0815 20.8871 31.9314 21.0374 31.7421L28.4962 22.3708C29.1137 21.595 29.1137 20.2883 28.4799 19.4921Z",
    fill: "#BD945B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrowBottom.b26402682f5704ab5f590e8e48198ee9.svg";
export { ForwardRef as ReactComponent };